<template>
  <div class="pagination-container">
    <button class="active" @click="changePage(1)">
      <feather-icon icon="ChevronsLeftIcon" size="16px" />
    </button>
    <button class="active" @click="changePage(currentPage - 1)">
      <feather-icon icon="ChevronLeftIcon" size="16px" />
    </button>

    <button v-for="page in totalPages" :key="page"
            :class="{'active': currentPage === page}"
            @click="changePage(page)"
            :disabled="currentPage === page">
      {{ page }}
    </button>

    <button class="active" @click="changePage(currentPage + 1)">
      <feather-icon icon="ChevronRightIcon" size="16px" />
    </button>
    <button class="active" @click="changePage(totalPages)">
      <feather-icon icon="ChevronsRightIcon" size="16px" />
    </button>
  </div>
</template>

<script>
export default {
  name: "pagination",
  props: {
    currentPage: {
      type: Number,
      required: true
    },
    totalPages: {
      type: Number,
      required: true
    }
  },
  methods: {
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.$emit('update:currentPage', page);
      }
    }
  }
}
</script>

<style scoped lang="scss">
.pagination-container {
  display: flex;
  justify-content: center;

  button {
    border: none;
    background: transparent;

    align-items: center;
    display: flex;
    justify-content: center;

    width: 24px;
    font-size: 1.25rem;

    cursor: pointer;
    color: #ccc;

    &.active {
      color: #7e72f2;
    }
  }
}
</style>
